import React, { createContext, useContext, useMemo } from "react";
import { KommunaltGalleriService, type KommunaltGalleriSettings } from "../features/admin/services/kommunaltGalleriService";

const KommunaltGalleriServiceContext = createContext<KommunaltGalleriService | null>(null);

export const KommunaltGalleriServiceProvider: React.FC<{ settings: KommunaltGalleriSettings; children: React.ReactNode }> = ({ settings, children }) => {
    const service = useMemo(() => {
        const s = new KommunaltGalleriService();
        s.configure(settings);
        return s;
    }, [settings]);

    return (
        <KommunaltGalleriServiceContext.Provider value={service}>
            {children}
        </KommunaltGalleriServiceContext.Provider>
    );
};

export const useKommunaltGalleriService = () => {
    const ctx = useContext(KommunaltGalleriServiceContext);
    if (!ctx) throw new Error("useKommunaltGalleriService must be used within a KommunaltGalleriServiceProvider");
    return ctx;
};
